import * as Common from '@tfo/common'
import { DiscrepancyIndicator } from '@tfo/common'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import { WrappedComponentProps, injectIntl } from 'react-intl'
import { displayNationalId } from '../../../../../../../utils/NationalId'
import '../ReportsItem.scss'
import ReadReceiptsIndicator from './ReadReciptsIndicator'
import ReportsItemDate from './ReportsItemDate'

export interface ReportsItemDeliveredProps {
	data: Common.models.IOrderClient
	onClick: any
	reportPackages: Common.models.ReportPackage[]
	showCompanyName: boolean
	isUnread: boolean
}

const ReportsItemDelivered = ({
	data,
	intl,
	isUnread,
	onClick,
	reportPackages,
	showCompanyName,
}: ReportsItemDeliveredProps & WrappedComponentProps) => (
	<div
		className={classNames(['ReportsItem', 'ReportsItem--standard', onClick && 'ReportsItem--active', isUnread && 'ReportsItem--isNew'])}
		data-cy={'deliveredOrder'}
		id={'reportsItem_' + data.id.toString()}>
		<div className={'ReportsItem__Inner '} onClick={onClick}>
			{showCompanyName && (
				<div className={'ReportsItem__Cell'}>{data.companyName}</div>
			)}
			<div className={'ReportsItem__Cell'}>
				{reportPackages.find(x => x.id === data.servicePackageId)
					?.customName ?? ''}
			</div>
			<div className={'ReportsItem__Cell ReportsItem__Cell--centerAlign'}>
				{data?.candidate?.firstName}
			</div>
			<div className={'ReportsItem__Cell ReportsItem__Cell--centerAlign'}>
				{data?.candidate?.lastName}
			</div>
			<div className={'ReportsItem__Cell ReportsItem__Cell--centerAlign'}>
				{displayNationalId(data?.candidate)}
			</div>
			<ReportsItemDate
				date={data.availableTo}
				label={intl.formatMessage({
					id: 'client.reports.item.labels.availableTo',
				})}
			/>
			{!!data.reportSummary && (
				<DiscrepancyIndicator
					className={'ReportsItem__ReportSummary'}
					title={intl.formatMessage({ id: 'common.reportWithDiscrepancy' })}
					body={data.reportSummary}
				/>
			)}
		</div>
		{!!data.readReceipt?.length && <ReadReceiptsIndicator readReceipts={data.readReceipt} intl={intl} />}
	</div>
)
export default injectIntl(observer(ReportsItemDelivered))
